


















































import {
  defineComponent,
  onMounted,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import PrettyCheck from 'pretty-checkbox-vue/check';

import {
  getLives,
  activateStatus,
  deleteLive,
} from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PageColumnWithLiveList = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const { route, router } = useRouter();

    const lives = ref([]);
    const pagination = ref({});

    const callGetLives = async () => {
      const { data, ...paginatorData } = await getLives();
      lives.value = data;
      pagination.value = paginatorData;
    };

    onMounted(async () => {
      await callGetLives();
    });

    const navigationHandler = (id: number) => {
      let redirectRouteName = 'LinkSetting';
      if (route.value.meta.display === 'Agenda') redirectRouteName = 'AgendaWithLive';
      else if (route.value.meta.display === 'Vote') redirectRouteName = 'VoteWithLive';
      else if (route.value.meta.display === 'Quiz & Ranking') redirectRouteName = 'QuizWithLive';
      else if (route.value.meta.display === 'Q & A') redirectRouteName = 'QAWithLive';
      else if (route.value.meta.display === 'Setting') redirectRouteName = 'MenuSetting';
      else if (route.value.meta.display === 'Live Chat') redirectRouteName = 'LiveChat';
      router.push({
        name: redirectRouteName,
        params: { liveId: id },
      });
    };

    const setActiveStatus = async (id: number, status: boolean) => {
      const index = lives.value.findIndex((elm: any) => elm.id === id);
      await activateStatus(id, 'session');
      (lives.value[index] as any).status = status;
      await callGetLives();
    };

    const deleteStreamingModal = ref(null);
    const openDeleteStreamingModal = (id: number) => {
      (deleteStreamingModal.value as any).compose({ id, action: 'ลบ', entity: 'Session' });
    };
    const deleteSession = async (ctx: { id: number }) => {
      await deleteLive(ctx.id);
      await callGetLives();
    };

    return {
      lives,
      pagination,

      navigationHandler,

      setActiveStatus,

      deleteStreamingModal,
      openDeleteStreamingModal,
      deleteSession,
    };
  },
});

export default PageColumnWithLiveList;
